import React, { CSSProperties } from "react";
import * as styles from "./velavu-table-header.module.scss";
import { classArr } from "../helper/style-helper";

export function VelavuTableHeader(props: {
	children?: React.ReactNode;
	className?: string;
}) {
	return (
		<div className={classArr(styles.tableHeaderRow, props.className)}>
			{props.children}
		</div>
	);
}

type VelavuTableColumnSizing =
	| {
			width: number;
	  }
	| {
			flex: number;
	  };

export interface VelavuTableColumnOptions {
	sizing?: VelavuTableColumnSizing;
	alignment?: "start" | "center" | "end";
}

export interface VelavuTableColumnProps extends VelavuTableColumnOptions {
	className?: string;
	onClick?: VoidFunction;
	children?: React.ReactNode;
}

export function VelavuTableColumn(props: VelavuTableColumnProps) {
	return (
		<div
			className={classArr(styles.tableColumn, props.className)}
			style={velavuTableColumnOptionsToStyle(props)}
			onClick={props.onClick}
		>
			{props.children}
		</div>
	);
}

export function VelavuTableHeaderLabel(
	props: {
		children?: React.ReactNode;
	} & VelavuTableColumnOptions,
) {
	return (
		<div
			className={`${styles.tableHeader} ${styles.tableColumn}`}
			style={velavuTableColumnOptionsToStyle(props)}
		>
			{props.children}
		</div>
	);
}

export function velavuTableColumnOptionsToStyle(
	options: VelavuTableColumnOptions,
): CSSProperties {
	const properties: CSSProperties = {};
	properties.justifyContent = options.alignment ?? "start";

	if (options.sizing !== undefined && "width" in options.sizing) {
		properties.width = options.sizing.width;
	} else {
		//Default to flex 1
		properties.flex = options.sizing?.flex ?? 1;
	}

	return properties;
}
